import axios from "../../../../../axios";
import API_BASE_URL from "../../../../config/runtimeConfig";
import Cookies from "js-cookie";

// services/jobService.js
// Author: Harshada Bhavsar 28-8-2025
// API: Get Sent Candidates For Jobs 
export const getSentCandidateforJobEmp = async (jobUID) => {
  const token = Cookies.get("employeeToken");
  return axios.post("/api/Candidate/GetCandidatesForJob", {
    token,
    jobUID,
  });
};

// View Resume API For Employee
export const viewResumeUrl = (resumePath) => {
  const token = Cookies.get("employeeToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};

export const VerifyCandidate = async (payload) => {
  return axios.post("/api/Jobs/VerifyCandidate", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}; 

// Send Candidate API
export const EmpSendCandidate = async (payload) => {
  const formData = new FormData();

  formData.append("Token", payload.Token);
  formData.append("RequestID", payload.RequestID);
  formData.append("CurrentCTC", payload.CurrentCTC || "");
  formData.append("ExpectedCTC", payload.ExpectedCTC || "");
  formData.append("TotalExperience", payload.TotalExperience || "");
  formData.append("CurrentLocation", payload.CurrentLocation || "");
  formData.append("NoticePeriod", payload.NoticePeriod || "");
  formData.append("ReadytoRelocate", String(payload.ReadytoRelocate));
  formData.append("ReasonofLeaving", payload.ReasonofLeaving || "");
  formData.append("Gender", payload.Gender || "");
  formData.append("PreferredLocation", payload.PreferredLocation || "");
  formData.append("CurrentCompany", payload.CurrentCompany || "");
  formData.append("Remarks", payload.Remarks || "");
  formData.append("Qualification", payload.Qualification || "");
  formData.append("DomainExperience", payload.DomainExperience || "");

  if (payload.ResumeFile) {
    formData.append("ResumeFile", payload.ResumeFile);
  }

  return axios.post("/api/Jobs/SubmitCandidate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};